module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms02_jp.d406b23e66bd3811e3e959b5573bd450.png";